import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'formatNumberPipe',
})
export class FormatNumberPipe implements PipeTransform {
  transform(input: string,): any {
  if (!input) return '';
    // Block alphabetic input
    input = input.replace(/[a-zA-Z]/g, '');
    // If starts with '+1', enforce '+1 (XXX) XXX XXXX' format
    if (input.startsWith('+1')) {
      if (input.length > 2 && input[2] !== ' ') {
        input = '+1 ' + input.slice(2);
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
    }
    // If starts with '(', enforce '(XXX) XXX XXXX' format
    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      console.log(formatted , 'FORMATTED')
      return formatted;
    }
    // If only digits, format as '(XXX) XXX XXXX'
    if (/^\d+$/.test(input)) {
      let digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    // Allow '+', '+1', '+1 ' as valid prefixes
    if (input === '+' || input === '+1' || input === '+1 ') {
      return input;
    }
    // For any other input, clear the field
    return '';
  }
}